import { configureStore } from '@reduxjs/toolkit';
import createRootReducer from 'app/config/Redux/global.reducer';

const store = configureStore({
	reducer: createRootReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore react-router related props
				ignoredActions: ['persist/PERSIST'],
				ignoredPaths: ['router'],
			},
		}),
	devTools: process.env.REACT_APP_ENV === 'development',
});

export default store;
